import StaticPageLayout from './StaticPageLayout';

export default function TermsOfUsePage() {
  return <StaticPageLayout title="Nutzungsbedingungen"></StaticPageLayout>;
}
